import { CITATION_ID_PATTERN } from '../../../citationIds';

/**
 * Removes citation / attachment markers from clinical impression markdown.
 * Matches Lexical import patterns in transformers.ts (footnote_ref, GFM-style footnotes).
 */
export function stripCitationMarkersFromMarkdown(markdown: string): string {
  let s = markdown;
  // [footnote_ref:1:docRef] — primary attachment/citation syntax
  s = s.replace(/\[footnote_ref:\d+:[^\]]*]/g, '');
  // [^id] inline footnote references
  s = s.replace(new RegExp(`\\[\\^${CITATION_ID_PATTERN}\\](?!:)`, 'g'), '');
  // [^id]: footnote definition lines
  s = s.replace(
    new RegExp(`^\\[\\^${CITATION_ID_PATTERN}\\]:[^\\n]*\\n?`, 'gm'),
    '',
  );
  return s;
}
